import { RadioField, TextPassage } from '@petsmart-ui/sparky';

type UnavailableDeliveryMethodProps = {
    deliveryMethod: string;
    isLoading?: boolean;
};

export default function UnavailableDeliveryMethod({
    deliveryMethod,
    isLoading,
}: Readonly<UnavailableDeliveryMethodProps>) {
    return (
        <RadioField.Item
            disabled
            text={
                <span
                    data-testid="test-delivery-method-name"
                    className="radio-field-title sparky-u-theme-typography-body-lg-bold"
                >
                    {deliveryMethod}
                </span>
            }
            itemAfter={
                <TextPassage
                    data-testid="unavailable-component"
                    className="delivery-method-status sparky-u-color-utility-error"
                >
                    {isLoading ? <>&nbsp;</> : <>Not available for this item</>}
                </TextPassage>
            }
        />
    );
}
